"use client";

/* eslint-disable react/require-default-props */
import { ReactNode } from "react";
import ScrollElement from "../mixins/scroll-element";

interface IElement {
  name: string;
  parentBindings?: any;
  children: ReactNode;
}
function Element(props: IElement) {
  const { parentBindings, ...restProps } = props;

  return (
    <div {...restProps} ref={(el) => { parentBindings.domNode = el; }}>
      {props.children}
    </div>
  );
}

export default ScrollElement(Element);
